if (!customElements.get('feature-popup')) {
    customElements.define(
        'feature-popup',
        class FeaturePopup extends DrawerComponent {
            constructor() {
                super();
            }

            connectedCallback() {
                super.connectedCallback();
                // document.getElementById("feature-popup-opener").addEventListener('click', e => {
                //     window.FoxTheme.DOMready(this.handleOpen.bind(this));
                // })
            }

            prepareToShow() {
                super.prepareToShow();
            }

            handleOpen() {
                setTimeout(() => {
                    this.show();
                }, 5000);
            }
        }
    );
}
